function stringToLocalTime(time = '', ifSecond = false) {    // 14:15:23  ==> 02:15 PM
    if (!time) {
        return
    }
    const [hours, minutes, seconds] = time.split(':')
    const suffix = parseInt(hours, 10) >= 12 ? 'PM' : 'AM';
    let hours12Format = (parseInt(hours, 10) % 12) || 12;
    hours12Format = hours12Format < 10 ? `0${hours12Format}` : hours12Format

    if (seconds && ifSecond) {
        return `${hours12Format}:${minutes}:${seconds} ${suffix}`;
    }
    return `${hours12Format}:${minutes} ${suffix}`;
}

const YYYYMMDDFormat = (ISOdate, symbol = '-') => {
    symbol = symbol ? symbol : ''
    const year = ISOdate?.getFullYear();
    const month = String(ISOdate.getMonth() + 1).padStart(2, '0');
    const day = String(ISOdate.getDate()).padStart(2, '0');

    return `${year}${symbol}${month}${symbol}${day}`;
}

const DDMMYYYYFormat = (ISOdate, symbol = '-') => {
    symbol = symbol ? symbol : ''
    const year = ISOdate?.getFullYear();
    const month = String(ISOdate.getMonth() + 1).padStart(2, '0');
    const day = String(ISOdate.getDate()).padStart(2, '0');

    return `${day}${symbol}${month}${symbol}${year}`;
}

const formatDateToYYYYMMMDD = (date) => {
    if (!(date instanceof Date)) return '';

    const year = date.getFullYear();
    const month = date.toLocaleString('en-US', { month: 'short' }); // Jun, Jul, etc.
    const day = String(date.getDate()).padStart(2, '0');

    return `${year} ${month} ${day}`;
};

const YYYYMMFormat = (ISOdate, symbol = '-') => {
    symbol = symbol ? symbol : ''
    const year = ISOdate?.getFullYear();
    const month = String(ISOdate.getMonth() + 1).padStart(2, '0');

    return `${year}${symbol}${month}`;
}

const getTimeFromSecond = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    let time = ''
    if (hours) {
        time = `${hours}h `
    }
    if (minutes) {
        time = time + `${minutes}m`
    }
    return time;
}

const secondsToHHMM = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
}

const formatTimeSeconds = (time) => {
    const hours = Math.floor(time / 3600000);
    const minutes = Math.floor((time % 3600000) / 60000);
    const seconds = Math.floor((time % 60000) / 1000);

    const pad = (value) => (value < 10 ? `0${value}` : value);

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

function convertIsoToAmPm(isoString) {
    // Parse the ISO string into a Date object
    const date = new Date(isoString);

    // Get hours, minutes, and seconds
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Format hours for AM/PM
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours < 10 ? '0' + hours : hours;

    // Pad minutes and seconds with leading zeros if needed
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;


    // Combine parts
    return `${hours}:${minutesStr} ${ampm}`;
}

export const HHMMSSFormate = (isoString) => {
    // Parse the ISO string into a Date object
    const date = new Date(isoString);

    // Get hours, minutes, and seconds
    let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    // Combine parts
    return `${hours}:${minutes}:${seconds}`;

}

export const HHMMFormate = (isoString) => {
    // Parse the ISO string into a Date object
    const date = new Date(isoString);

    // Get hours, minutes, and seconds
    let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();

    // Combine parts
    return `${hours}:${minutes}`;

}

const formateDateToDayText = (isoDate) => {
    const date = new Date(isoDate);
    const today = new Date();

    // Normalize dates to ignore time for comparison
    today.setHours(23, 59, 59, 999);
    date.setHours(23, 59, 59, 999)

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const nextSeventhDay = new Date(today);
    nextSeventhDay.setDate(today.getDate() + 6);

    const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);

    if (date.getTime() === today.getTime()) {
        return 'Today';
    } else if (date.getTime() === yesterday.getTime()) {
        return 'Yesterday';
    } else if (date.getTime() === tomorrow.getTime()) {
        return 'Tomorrow';
    } else if (date.getFullYear() === today.getFullYear() && date.getTime() > today.getTime() && date.getTime() <= nextSeventhDay.getTime()) {
        return `${dayOfWeek}`;
    } else if (date.getFullYear() === today.getFullYear()) {
        return `${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
    } else {
        return `In ${formattedDate}`;
    }
}

const getBetweenPeriods = (fromDate, toDate, type) => {
    let dateArray = []

    let i = null
    switch (type) {
        case 'Days':

            return dateArray
        case 'Weeks':

            return dateArray
        case 'Months':
            i = structuredClone(new Date(fromDate));
            while (i <= new Date(toDate)) {
                const date = new Date(i.getFullYear(), i.getMonth(), 1);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                dateArray.push(`${year}-${month}`);

                i = new Date(new Date(i).setMonth(new Date(i).getMonth() + 1))
            }
            return dateArray;
        case 'Years':

            i = structuredClone(new Date(fromDate));
            const endYear = new Date(toDate).getFullYear();
            while (i.getFullYear() <= endYear) {
                const year = i.getFullYear();
                dateArray.push(`${year}`);

                i.setFullYear(year + 1);
            }
            return dateArray;
        default:
            throw new Error('Invalid time type');
    }
}




export {
    stringToLocalTime, YYYYMMDDFormat, getTimeFromSecond, secondsToHHMM, convertIsoToAmPm, formateDateToDayText, YYYYMMFormat,
    formatTimeSeconds, getBetweenPeriods, formatDateToYYYYMMMDD, DDMMYYYYFormat
}